import React, { useEffect } from 'react'
import Logo from '../../componetns/logo'
import { useHistory, Link } from "react-router-dom"
import BackButton from "../img/back-button.png"
import LogoMain from '../images/logo.svg'
import LogoDarkAnimator from '../../componetns/logoDarkAnimator'

const MobileHeader = () => {
    let history = useHistory();
    const GoBackPage = () => {
        history.goBack();
    }
    const goToTop = () => {
        window.scrollTo({
            top: 100,
            behavior: 'smooth',
        });
    };
    return (
        <div>
            <div className="Mobile_header">
                <button onClick={() => { GoBackPage(); goToTop() }} className="btn mobile_back">
                    <img src={BackButton} alt="" />
                </button>
                {/* <img src={LogoMain} alt="logo" /> */}
                <Link to="/">
                    <LogoDarkAnimator />
                </Link>
                <div className=""></div>
            </div>
        </div>
    )
}

export default MobileHeader